<template>
  <div class="dd-view">
    <div class="dd_top">
      <img
        class="dd_back"
        src="https://img.yzcdn.cn/upload_files/2020/08/24/Fhc61mPCy7ytbnTEN3mdZADF-E4l.png"
        @click="back"
      />
      <form action="javascript:return true" class="search" onsubmit="return false;">
        <input
          ref="input"
          type="search"
          placeholder="请输入您要搜索的内容"
          readonly
          @click="togglePage('search')"
        />
      </form>
      <img
        class="dd-scan"
        src="https://img.yzcdn.cn/upload_files/2020/08/24/FpOrLdvoPCAUrqcNBqAiougAWaxe.png"
        @click="handleFindBook"
      />
      <div class="dd-select" :class="isVer ? 'all' : ''">
        <GradeSelect
          v-if="!toggleEle"
          key="select"
          v-model="grade"
          @on-confirm="changeWbGrade"
          @change="gradeChange"
        >
          <div class="select">
            <span>{{ grade }}</span>
            <img
              src="https://img.yzcdn.cn/upload_files/2020/08/24/FtpCZKhTlDxIhLYVrqb5DwzdSnrx.png"
            />
          </div>
        </GradeSelect>
        <VersionSelect v-if="isVer" key="version" v-model="version" @on-confirm="changeWbVersion">
          <div class="select">
            <span>选择版本</span>
            <img
              src="https://img.yzcdn.cn/upload_files/2020/08/24/FtpCZKhTlDxIhLYVrqb5DwzdSnrx.png"
            />
          </div>
        </VersionSelect>
      </div>
    </div>

    <div class="dd_main">
      <router-view />
    </div>
    <FindBook :show="findBook" @on-back="() => (findBook = false)" @on-click="clickScanQRCode" />
    <form id="scanForm" action="/cms/weixin/workbook/add/search" method="post">
      <input type="hidden" name="addType" value="1" />
      <input id="scanOpenId" v-model="openid" type="hidden" name="openid" />
      <input id="scanSn" v-model="scanResult" type="hidden" name="sn" />
    </form>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant'
import { gardTranslate, termTranslate } from '@/pages/vipHome/js/index.js'
import GradeSelect from '../component/selectGrade'
import VersionSelect from '../component/versionSelect'
import { checkScanQrCode, getformData, setCookie } from '../../../../../library/index'
import FindBook from '@/pages/answer/component/findBook'
export default {
  name: '',
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    GradeSelect,
    FindBook,
    VersionSelect
  },
  props: {
    toggleEle: {
      type: Boolean,
      defaule: false
    }
  },
  data() {
    const arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
    const arr2 = ['', '(上)', '(下)']
    const {
      userPref: { wbGrade, wbVersion }
    } = this.$store
    const grade = wbGrade
      ? arr1[wbGrade.substring(5).substring(0, 1)] +
        '年级' +
        arr2[wbGrade.substring(5).substring(1, 2)]
      : '选择年级'
    const version = wbVersion
    return {
      isVer: false,
      page: '',
      value1: 0,
      value2: 'a',
      grade: grade,
      term: '',
      findBook: false, // 搜书
      scanResult: '', // 扫码结果
      version: version
    }
  },
  computed: {
    openid() {
      return this.$store.openid
    },
    userPref() {
      return this.$store.userPref
    }
  },
  watch: {
    '$route.path': {
      handler: function(val) {
        if (val === '/kbMore') {
          this.isVer = true
        } else {
          this.isVer = false
        }
      },
      immediate: true
    }
  },
  methods: {
    gardTranslate,
    termTranslate,
    gradeChange(value) {
      this.grade = value.text
    },
    // 点击函数，更改用户年级，参数为选中的数据
    changeWbGrade(selectItem) {
      const {
        userPref: { wbGrade }
      } = this.$store
      const { grade, volume } = selectItem
      const wbGrade1 = `grade${grade}${volume}`
      if (wbGrade !== wbGrade1 && grade && volume) {
        this.saveUserPreferences(wbGrade1, '', (data) => {
          if (window.Statistic) {
            window.Statistic.changeGrade({
              app: 'shanxiCms',
              grade: grade + '' + volume, // 年级加学期
              openid: this.$store.userInfo.openid,
              vip: this.$store.userInfo.vipLevel
            })
          }
        })
      }
    },
    // 切换版本 可多选  且和答案核对版本选择同步
    changeWbVersion(selectItem) {
      const {
        userPref: { wbVersion }
      } = this.$store
      let version = 'all'
      const res = selectItem.map((item) => `${item}`).join(',')
      if (res) {
        version = res
      }
      if (wbVersion !== version) {
        this.saveUserPreferences('', version)
      }
    },
    // 保存userPreferences,保存年级或者版本(多选)
    saveUserPreferences(grade1, version1) {
      const {
        userPref: { wbGrade, wbVersion },
        openid
      } = this.$store
      var grade = grade1 || wbGrade
      // 基于用户不会无版本的逻辑
      var version = version1 || wbVersion || 'all'
      var changeGrade = grade !== wbGrade
      var changeVersion = version !== wbVersion
      if (changeGrade || changeVersion) {
        const userPrefString = grade + ':' + version
        return this.$http
          .post(
            '/cms/weixin/hw/saveUserPreferences',
            getformData({
              openid: openid,
              userPref: userPrefString
            })
          )
          .then((res) => {
            if (res.data && res.data.openid) {
              this.$store.userPref = res.data
              setCookie('userPref', JSON.stringify(res.data), 1)
              this.$store.commit('user/setUserPref', res.data)
            }
          })
      }
    },
    // 扫码求书
    handleFindBook() {
      this.findBook = true
    },
    //  求书扫码
    clickScanQRCode() {
      this.$wechatJsSdk.then((wx) => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            if (res.errMsg === 'scanQRCode:ok') {
              if (checkScanQrCode(result)) {
                window.location.href = `/cms/webapp/home/answer/#/findbook/findresult?barCode=${result}`
              }
            }
          },
          fail: function(err) {

          }
        })
      })
    },
    togglePage() {
      this.$router.push('/search')
    },
    back() {
      window.history.back()
    }
  }
}
</script>

<style lang="scss">
.dd-view {
  height: 100vh;
  .dd_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px 19px 0;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    .dd_back {
      width: 10px;
    }
    .dd-scan {
      width: 20px;
    }
    .search {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.37rem;
      width: 262.5px;
      height: 33px;
      background: #f5f7fa;
      border-radius: 6px;
      // color: #BEC2C6;
      .seach-input {
        text-align: center;
      }
      input[type='search'] {
        -webkit-appearance: none;
        // 也可以去除加上border: 0;之类的 根据设计图来
      }
      input::-webkit-search-cancel-button {
        -webkit-appearance: none;
        position: relative;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background: url('https://img.yzcdn.cn/upload_files/2020/08/12/Fnt9L98o7VBexWXTgi0fVnVLmj-Y.png')
          no-repeat center;
        background-size: 100% 100%;
      }
      input[type='search']::-ms-clear {
        color: transparent;
        position: relative;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background: url('https://img.yzcdn.cn/upload_files/2020/08/12/Fnt9L98o7VBexWXTgi0fVnVLmj-Y.png')
          no-repeat center;
        background-size: 100% 100%;
      }
      input {
        width: 100%;
        text-indent: 0.47rem;
        /* padding-right: 0.2rem; */
        font-size: 0.35rem;
        background: url(https://img.yzcdn.cn/upload_files/2020/08/24/Fok-cYDidyQdwt59odIfV6t1t5Nb.png)
          no-repeat;
        background-position: 12px;
        padding-left: 16px;
        padding-right: 10px;
        background-size: 12.5px 12.5px;
        color: #333;
      }
    }
    .dd-select {
      width: 100%;
      font-weight: 500;
      font-size: 15px;
      padding: 15px 0 15px 0px;
      line-height: 1;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      &.all {
        padding: 15px 52px 15px 52px;
        justify-content: space-between;
      }
      .select {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 6px;
        margin-left: 6px;
        margin-top: 2px;
      }
    }
  }
  .dd_main {
    background: #f5f5f5;
    position: relative;
    top: 84px;
  }
}
</style>
